import '../styles/default.css'
import '../styles/index-styles.css'
import '../styles/screen-sponsors.css'
import '../styles/screen-speakers.css'

import './jquery.fullpage.min'
import './timer'
import './owl.carousel.min'
import './jquery.magnific-popup.min'
import './lazy'
import './jquery.touchSwipe.min'

$(".about__video-cover, .about__video-icon").on("click", function () {
  $(".about__video-cover, .about__video-header").fadeOut();
  player.playVideo();
});
$(".about__video-frame").on("click", function () {
  $(".about__video-cover, .about__video-header").fadeIn();
  player.pauseVideo();
});

$(function () {
  $(".cookies__close").on("click", function() {
    $(".cookies").hide();
  });

  $(".sidebar__toggle").on("click", function(e) {
    e.preventDefault();
    $("#menu").toggleClass("active");
  });

  $(".menu__close").on("click", function(e) {
    e.preventDefault();
    $("#menu").removeClass("active");
  });

  // menu close esc
  $(document).on("keydown",function(e) {
    var menu = $("#menu");
    if(menu.hasClass("active")) {
      switch (e.keyCode) {
        case 27: //esc
          menu.removeClass("active");
          break;
      }
    }
  });

  $(".menu__link").on("click", function() {
    $("#menu").removeClass("active")
    $(".menu__link").removeClass("active");
    $(this).addClass("active");
    if(!($('html').hasClass('fp-enabled'))) {
      var $this = $(this),
        menu = $("#menu"),
        sectionName = $this.data("menuanchor"),
        top = window.innerWidth > 1068 ? $(".section[data-anchor='" + sectionName + "']").offset().top : $(".section[data-anchor='" + sectionName + "']").offset().top - $(".sidebar").innerHeight();

      menu.find(".active").removeClass("active");
      $this.addClass("active");
      $("html, body").animate({
        scrollTop: top
      }, 0);
    }
  });

  // hide/show mobile menu
  if(window.innerWidth <= 1068) {
    var previous = window.scrollY,
      menu = $(".sidebar");
    $(window).on("scroll", function() {
      var direction = window.scrollY > previous ? 'down' : 'up',
        scrollTop = $("html, body").scrollTop(),
        screenHeight = $(window).innerHeight();
      previous = window.scrollY;
      if(direction == 'down' && menu.hasClass("hidden") == false && scrollTop > screenHeight) {
        menu.addClass("hidden");
      }
      if(direction == 'up' && menu.hasClass("hidden")) {
        menu.removeClass("hidden");
      }
    });
  }
  const pathArr = window.location.pathname.split('/')
  $('.lang__item').on('click', function () {
    const pathArr = window.location.pathname.split('/')
    if ($(this).hasClass('lang-en')) {
      pathArr[pathArr.length - 2] = 'en'
    } else {
      pathArr[pathArr.length - 2] = 'ru'
    }
    window.location.pathname = pathArr.join('/')
  });

});

if(window.innerWidth > 1068) {
  $(window).on("load scroll", function() {
    $('.animate').each(function() {
      if (isScrolledIntoView(this) === true) {
        var animateClasses = $(this).data("animate");
        $(this).removeClass("animate").addClass(animateClasses);
      }
    });
  });
}

function isScrolledIntoView(elem) {
  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height();
  var elemTop = $(elem).offset().top;
  var elemBottom = elemTop + $(elem).height();
  return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

$(window).on("resize", function(e) {
  afterpartySlider.docWidth = window.innerWidth;
  return false;
});

var owlReviews = $('#previuosly-slider').owlCarousel({
  loop:true,
  margin: 20,
  items: 1,
  nav: true,
  dots: false,
  animateIn: 'reviewFadeIn',
  autoHeight: false,
  responsiveClass:true,
  autoplay: true,
  autoplayTimeout: 10000,
  autoplayHoverPause: true,
});

var gallery = $("#previously-gallery");
if(window.innerWidth <= 400) {
  gallery.find(".previously__galleryItem").each(function() {
    var $this = $(this),
      mobileImg = $this.data("mobile");
    $this.css("backgroundImage", "url(" + mobileImg + ")");
  });
  gallery.addClass("owl-carousel");

  var owlGallery = gallery.owlCarousel({
    responsiveClass:true,
    items: 1,
    nav: false,
    dots: true,
    margin: 0,
    loop: true
  });
} else {
  gallery.removeClass("owl-carousel");
}

$(window).on("resize", function() {
  if(window.innerWidth <= 400 && gallery.hasClass("owl-carousel") == false) {
    gallery.find(".previously__galleryItem").each(function() {
      var $this = $(this),
        mobileImg = $this.data("mobile");
      $this.css("backgroundImage", "url(" + mobileImg + ")");
    });
    gallery.addClass("owl-carousel");

    owlGallery = gallery.owlCarousel({
      responsiveClass:true,
      items: 1,
      nav: false,
      dots: true,
      margin: 0,
      loop: true
    });
  } else if(window.innerWidth > 400 && gallery.hasClass("owl-carousel") == true) {
    gallery.find(".previously__galleryItem").each(function() {
      var $this = $(this),
        mobileImg = $this.data("mobile").replace("-mobile", "");
      $this.css("backgroundImage", "url(" + mobileImg + ")");
    });
    gallery.removeClass("owl-carousel");
    owlGallery.trigger('destroy.owl.carousel');
  }
});

$(".previously__gallery-link").magnificPopup({
  type: 'image',
  gallery: {
    enabled: true
  },
});

$(".afterparty__gallery-link").magnificPopup({
  type: 'image',
  gallery: {
    enabled: true
  },
  image: {
    verticalFit: true
  }
});

if(window.innerWidth <= 1068) {
  var previoslyScrollTop = Math.ceil($(".previously__list").offset().top) - window.innerHeight;

  $(window).on("scroll load", function() {
    var html = document.documentElement, body = document.body,
      scrollTop = html && html.scrollTop || body && body.scrollTop || 0;
    if(scrollTop > previoslyScrollTop && $(".previously__list").hasClass("wasAnimate") == false) {
      $(".previously__list-num .number").each(function() {
        var $this = $(this),
          max = Number($this.data("number")),
          duration = 2500;
        animateNumber($(this), max, duration);
        $(".previously__list").addClass("wasAnimate");
      });
    }
  });
}

function animateNumber(el, max, duration) {
  var currentNumber = 0;
  $({numberValue: currentNumber}).animate({numberValue: max}, {
    duration: duration,
    easing: 'linear',
    step: function(currentLeft) {
      var num = Math.round(currentLeft);
      el.text(num);
    }
  });
}

$(window).on("load", function () {
  if (window.innerWidth <= 1068 && location.hash.length || !($(".fp-section").length)) {
    var hash = location.hash.replace("#", ""),
      el = $(".section__wrap[data-id='" + hash + "']"),
      offset = el.offset().top;
    console.log(hash, el, offset);

    if(el.length) {
      $(".menu__link[data-menuanchor='" + hash + "']").addClass("active");
      $("html, body").animate({
        scrollTop: offset
      }, 500);
    }
  }
});


$(".packages__tab").on("click", function () {
  var $this = $(this),
    tarif = $this.data("tarif");

  changePackage(tarif);
  $this.addClass("selected");
  $(".packages h2.primaryCaption").addClass("opened");

  if(window.innerWidth <= 1068 || !($(".fp-section").length)) {
    $("html, body").animate({
      scrollTop: $(".packages__full-wrap.active").offset().top
    }, 300);
  }
});
$(".packages__full-close").on("click", function () {
  $("#packages-tabs").removeClass("small");
  $("#packages-full").removeClass("active platinum party premium exhibitor");
  $(".packages__tab.selected, .packages__full.selected").removeClass("selected");
  $(".packages h2.primaryCaption").removeClass("opened");
});
$(".packages__next").on("click", function () {
  var tarif = $(this).data("next");

  changePackage(tarif);
  $(".packages__tab-" + tarif).addClass("selected");
});
function changePackage(tarif) {
  $("#packages-tabs").addClass("small");
  $(".packages__tab.selected").removeClass("selected");
  $("#packages-full").removeClass("platinum party premium exhibitor").addClass("active").addClass(tarif);
  $(".packages__full").removeClass("selected");
  $("#" + tarif).addClass("selected");
}

// change # on scroll
var sectionsTop = [];
$(".section").each(function() {
  var $this = $(this),
    anchor = $this.data("anchor"),
    thisTop = Math.ceil($this.offset().top);

  sectionsTop.push({
    scrolltop: thisTop,
    anchor: anchor
  });
});

$(window).on("scroll", function() {
  var currentTop = $(document).scrollTop() - 300,
    hash = location.hash.replace("#", "");

  var fil = sectionsTop.filter(function(el, nextIndex, thisArray) {
    return el.scrolltop >= currentTop;
  });
});

$(document).ready(function() {
  // lazyload bg
  $(".lazy").each(function() {
    var $this = $(this),
      bgImg,
      windowSize = $(window).innerWidth();

    if( !(windowSize <= 400 && $this.data('mobile-gradient') == false) ) {
      switch (true) {
        case (windowSize > 1200):
          bgImg = $this.data("bg-desktop");
          break;
        case (windowSize <= 1200 && windowSize > 600):
          bgImg = $this.data("bg-tablet");
          break;
        default:
          bgImg = $this.data("bg-mobile");
      }

      $("<img src='" + bgImg + "' />").bindImageLoad(function () {
        bgImg = "url(" + bgImg + ")";
        $this.css("backgroundImage", bgImg);
        $this.find(".blur-bg").fadeOut();
      });
    }
  });
});

if(window.innerWidth <= 1068) {
  $(".packages__full").swipe( {
    swipeRight:function() {
      var activeTab = $(".packages__full.selected"),
        newTab = activeTab.prev(".packages__full").length ? activeTab.prev() : $(".packages__full#exhibitor");

      activeTab.removeClass("selected");
      newTab.addClass("selected");
      $(".packages__full-wrap.active").removeClass("platinum party premium exhibitor").addClass($(newTab).attr("id"));
    },
    swipeLeft: function() {
      var activeTab = $(".packages__full.selected"),
        newTab = activeTab.next().length ? activeTab.next() : $(".packages__full#platinum");

      activeTab.removeClass("selected");
      newTab.addClass("selected");
      $(".packages__full-wrap.active").removeClass("platinum party premium exhibitor").addClass($(newTab).attr("id"));
    }
  });
}

var links = ['home', 'about', 'previously', 'program', 'program-2', 'speakers', 'speakers-2', 'afterparty', 'packages', 'sponsors', 'info', 'contacts'];
var fullpageDesktop = {
  menu: "#menu",
  anchors: links,
  css3: true,
  scrollingSpeed: 1000,
  responsiveHeight: 768,
  responsiveWidth: 1068,
  paddingTop: '0',
  paddingBottom: '0',
  afterLoad: function(anchorLink, index){
    // animations
    $('.section__wrap[data-id="' + links[index - 1] + '"] .animate').each(function() {
      var animateClasses = $(this).data("animate");
      $(this).removeClass("animate").addClass(animateClasses);
    });
    // hide/show scrollotop
    if(index == 1) {
      $('.scrolltop').addClass("hidden");
    } else {
      $('.scrolltop').removeClass("hidden");
    }
  },
  onLeave: function(index, nextIndex, direction) {

    // animations
    $('.section__wrap[data-id="' + links[index] + '"] .animate').each(function() {
      var animateClasses = $(this).data("animate");
      $(this).removeClass("animate").addClass(animateClasses);
    });

    if(nextIndex == 3) {
      // numbers animation (previously)
      if($(".previously__list").hasClass("wasAnimate") == false) {
        $(".previously__list-num .number").each(function() {
          var $this = $(this),
            max = Number($this.data("number")),
            duration = 2500;
          animateNumber($(this), max, duration);
          $(".previously__list").addClass("wasAnimate");
        });
      }
    }
    // hide/show scrollotop
    if(nextIndex == 1) {
      $('.scrolltop').addClass("hidden");
    } else {
      $('.scrolltop').removeClass("hidden");
    }
  }
};

var windowSize = window.innerWidth;
$('#fullpage').fullpage(fullpageDesktop);
// if(windowSize > 1068) {
//   $('#fullpage').fullpage(fullpageDesktop);
// }
//
// var currentFullpageOptions = (windowSize <= 1068) ? 'mobile' : 'desktop' ;
//
// $(window).on("resize", function() {
//   if(window.innerWidth <= 1068 && currentFullpageOptions != 'mobile') {
//     $.fn.fullpage.silentMoveTo(window.location.hash, 2);
//     currentFullpageOptions = 'mobile';
//     $.fn.fullpage.destroy('all');
//     var hash = location.hash.replace("#", ""),
//       el = $(".section__wrap[data-id='" + hash + "']");
//     if(el.length) {
//       $("html, body").animate({
//         scrollTop: el.offset().top - $(".sidebar").innerHeight() + 5
//       }, 500);
//     }
//   } else if(window.innerWidth > 1068 && currentFullpageOptions != 'desktop') {
//     $('#fullpage').fullpage(fullpageDesktop);
//     currentFullpageOptions = 'desktop';
//   }
// });


$(".scrolltop").on("click", function(e) {
  e.preventDefault();
  $.fn.fullpage.moveTo("home", 1);
});